import React, {useMemo, useEffect,useState } from "react";
import axios from 'axios'
import withRouter from "../../../../Components/Common/withRouter";
import defaultUserImg from "../../../../assets/images/defaultuserimgdark.png"
import { Badge, Card, CardBody, CardTitle,Col, Row, } from "reactstrap";
import { subscribeToTokenRefresh } from "../../../../helpers/Refreshfile";

import TableContainer from "../../../../Components/Common/TableContainer";
import { getTransaction as onGetTransaction } from "slices/thunk";
import { useDispatch } from "react-redux";
import { blogStatsDataType } from "./type";
import { Link } from "react-router-dom";
import { APIClient } from "../../../../helpers/api_helper";
const api = new APIClient();
const baseUrl = process.env.REACT_APP_BASE_URL;
// import avatar1 from "../../../../assets/images/users/avatar-1.jpg"
interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}


const LatestBooking: React.FC = () => {

  const dispatch = useDispatch<any>();
  const columns: column[] = useMemo(
          () => [
            {
              header: 'S.No',
              enableColumnFilter: false,
              enableSorting: false, 
              cell: ({ row, table }) => {
                  return row.index + 1;
              },
            },

              {
              header: 'Customer Info',
              accessorFn: (row: any) => {
                  console.log('check yaha ka rok',row)
                  const first_name = row?.cust?.user?.first_name || '';
                  const email = row?.cust?.user?.email || '';
                  return `${first_name} ${email}`;
              },
              enableColumnFilter: false,
              enableSorting: true,
              cell: (info: any) => {
                  const row = info.row.original;
                  const first_name = row?.cust?.user?.first_name;
                  const email = row?.cust?.user?.email;
                  const attachment = row?.cust?.user?.profile_pic;
              
                  return (
                    <div className="d-flex align-items-center">
                    <img
                      src={attachment ? `${baseUrl}${attachment}` : defaultUserImg}
                      alt="User"
                      width="50"
                      height="50"
                      className="rounded-circle object-fit-cover"
                      style={{ marginRight: '10px' }}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = defaultUserImg;
                      }}
                    />
                    <div>
                      <div className="fw-medium">{first_name || "No first name"}</div>
                      <div className="font-size-12">{email || "No email"}</div>
                    </div>
                  </div>
                  );
              }
              },
              
              {
                  header: 'Phone',
                  accessorKey: 'cust.user.phone',
                  enableColumnFilter: false,
                  enableSorting: true,
              },
              {
                  header: 'Booking Date',
                  accessorKey: 'seldate',
                  enableColumnFilter: false,
                  enableSorting: true,
                  cell: ({ row }: any) => { return ( <> {row.original.seldate} <br /> {row.original.seltimes?.hour} </> ); },
              },
              {
                  header: 'Category',
                  accessorKey: 'expert.category.name',
                  enableColumnFilter: false,
                  enableSorting: true,
              },
              {
                header: 'Session',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }: any) => {return `$${row.original?.expert_price} / ${row.original?.exp_session_mins} Mins`},
                // accessorFn: (row: any) => 
                //     row.expert?.expert_price 
                //         ? `$${row.expert.expert_price} / ${row.expert.exp_session_mins} mins` 
                //         : "0",
                        // item.expert_price ? `$${item.expert_price} / ${item.exp_session_mins} mins`  : 0,
              },
              {
                header: 'Status',
                accessorKey: 'status',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                  const status = row.original.status;
              
                  const badgeClass =
                    status === 'failed'
                      ? 'font-size-11 badge-soft-danger badge bg-secondary'
                      : 'font-size-11 badge-soft-success badge bg-secondary';
              
                  return (
                    <span className={badgeClass}>
                      {status}
                    </span>
                  );
                }
              }
          ],
          []
      );

  const [latestBooking, setlatestBooking] = useState<any[]>([]);
  const [Bookingcount, setBookingcount] = useState<any[]>([]);
  const [bookings, setBookings] = useState<any[]>([]);
  
      const fetch_customerlisting = async () => {
        try {
            // const userinfo_ = localStorage.getItem('authUser')
            // const user_role = localStorage.getItem('userole_')
            const response = await axios.post(`/accounts/expert_dashboard_details`);
            // const response = await api.get(`/accounts/expert_dashboard_details`, {
            //     params: {
            //         user_id: userinfo_,
            //         user_role: user_role
            //     }
            // });
            console.log('data in fetch_customerlisting__',response) 
            if (response.status === 'expert_details') {
                setBookings(response.bookings);
                const stats = [
                  {
                    title: "Total Bookings",
                    value: response.bking_count,
                    icon: "mdi mdi-calendar",
                  },
                  {
                    title: "Past Bookings",
                    value: response.past_bookings,
                    icon: "mdi mdi-history",
                  },
                  {
                    title: "Upcoming Bookings",
                    value: response.future_bookings,
                    icon: "mdi mdi-clock-outline",
                  },
                ];
              
                setBookingcount(stats);

            }
    } catch (error) {
        console.error('Not working', error);
    }
  };
      
      useEffect(() => {
        fetch_customerlisting();

        subscribeToTokenRefresh(() => {
          console.log("🔁 Token refreshed. Re-fetching experts...");
          fetch_customerlisting();
        });
      }, []);
    
      useEffect(() => {
      }, [latestBooking]);


  return (
    <React.Fragment>
      <Col lg={8}  className="order-lg-1 order-2">
        <Row>
          {(Bookingcount || [])?.map((stat: blogStatsDataType, index: number) => (
            <Col lg={4} key={index}>
              <Card className="blog-stats-wid rounded-4"> 
                <CardBody>
                  <div className="d-flex flex-wrap">
                    <div className="me-3">
                      <p className="text-muted mb-2 font-size-15">{stat.title}</p>
                      <h5 className="mb-0">{stat.value}</h5>
                    </div>
                    <div className="avatar-sm ms-auto">
                      <div className="avatar-title bg-light rounded-circle text-dark font-size-20">
                        <i className={stat.icon}></i>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
        <Row>
          <Col xl={12}>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <CardTitle tag="h4" className="mb-4">Latest Booking</CardTitle>
                  <Link to="/ebookings" className="btn btn-primary btn-sm">
                    View All
                  </Link>
                </div>
                <TableContainer
                    columns={columns}
                    // data={bookings || []}
                    data={bookings.slice(0, 10) || []}
                    isPagination={false}
                    // isGlobalFilter={true} for search bar
                    // SearchPlaceholder="Search By Name..." ---------- for search bar
                    pagination="pagination"
                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                    tableClass="table-bordered dt-responsive table-nowrap w-100 dataTable no-footer dtr-inline"
                    pageSize={10}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};


export default withRouter(LatestBooking);
